import React from 'react'
import WODMARK from '../../../../app/assets/images/projectImage/quivverImages/Wodmark.webp'
import BANNER from '../../../../app/assets/images/projectImage/quivverImages/banner.webp'
import NEONVALORANT from '../../../../app/assets/images/projectImage/quivverImages/Neon-Valorant-Dynamic.webp'

const QuivverBanner = () => {
    return (
        <>
            <style>{`
                @keyframes float {
                    0%, 100% { transform: translateY(0px) translateX(-50%); }
                    50% { transform: translateY(-20px) translateX(-50%); }
                }
                @keyframes floatCharacter {
                    0%, 100% { transform: translateX(-40%) translateY(0px); }
                    50% { transform: translateX(-40%) translateY(-15px); }
                }
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                @keyframes fadeInScale {
                    from {
                        opacity: 0;
                        transform: scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
                @keyframes slideInLeft {
                    from {
                        opacity: 0;
                        transform: translateX(-30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                @keyframes slideInRight {
                    from {
                        opacity: 0;
                        transform: translateX(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                @keyframes pulseGlow {
                    0%, 100% {
                        opacity: 0.2;
                    }
                    50% {
                        opacity: 0.3;
                    }
                }
                .animate-float {
                    animation: float 6s ease-in-out infinite;
                }
                .animate-float-character {
                    animation: floatCharacter 4s ease-in-out infinite;
                }
                .animate-fade-in-up {
                    animation: fadeInUp 1s ease-out forwards;
                }
                .animate-fade-in-scale {
                    animation: fadeInScale 1.2s ease-out forwards;
                }
                .animate-slide-in-left {
                    animation: slideInLeft 0.8s ease-out forwards;
                }
                .animate-slide-in-right {
                    animation: slideInRight 0.8s ease-out forwards;
                }
                .animate-pulse-glow {
                    animation: pulseGlow 4s ease-in-out infinite;
                }
                /* Responsive Pill positioning */
                @media (max-width: 639px) {
                    .pill-left {
                        left: 2% !important;
                        right: auto !important;
                    }
                    .pill-right {
                        right: 2% !important;
                        left: auto !important;
                    }
                    .pill-top-40 { top: 35% !important; }
                    .pill-top-53 { top: 43% !important; }
                    .pill-top-59 { top: 54% !important; }
                    .pill-top-74 { top: 65% !important; }
                    .pill-top-80 { top: 75% !important; }
                }
                @media (min-width: 640px) and (max-width: 767px) {
                    .pill-left {
                        left: 5% !important;
                        right: auto !important;
                    }
                    .pill-right {
                        right: 5% !important;
                        left: auto !important;
                    }
                    .pill-top-40 { top: 38% !important; }
                    .pill-top-53 { top: 51% !important; }
                    .pill-top-59 { top: 57% !important; }
                    .pill-top-74 { top: 72% !important; }
                    .pill-top-80 { top: 78% !important; }
                }
                @media (min-width: 768px) and (max-width: 1023px) {
                    .pill-left {
                        left: 10% !important;
                        right: auto !important;
                    }
                    .pill-right {
                        right: 1% !important;
                        left: auto !important;
                    }
                }
            `}</style>
            <section className="relative bg-[#0F0D16] overflow-hidden">
                {/* Background */}
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_40%_50%,rgba(45, 238, 154, 0.23),transparent_40%),radial-gradient(circle_at_80%_70%,rgba(45, 238, 154, 0.23),transparent_40%)] animate-pulse-glow" />

                <div className="relative max-w-[1400px] mx-auto px-6 pt-[14vh]">

                    {/* Watermark */}
                    <img
                        src={WODMARK}
                        className="absolute top-36 left-1/2 -translate-x-1/2 w-[90%] max-w-[900px] opacity-90 animate-float"
                    />

                    {/* Main phones container */}
                    <div className="relative flex justify-center items-center">

                        <img
                            src={BANNER}
                            className="w-[95vw] max-w-[900px] drop-shadow-[0_40px_80px_rgba(0,0,0,0.5)] animate-fade-in-scale"
                        />

                        {/* Character */}
                        <img
                            src={NEONVALORANT}
                            className="absolute bottom-[0%] left-1/2 -translate-x-[40%]
              w-[clamp(180px,28vw,360px)] z-20 animate-float-character"
                        />

                        {/* Pills */}
                        <Pill left="15%" top="40%" delay={0.2}>Game-wise event listings</Pill>
                        <Pill left="0%" top="59%" delay={0.4}>Live & upcoming tournaments</Pill>
                        <Pill left="2%" top="80%" delay={0.6}>Leaderboards updated in real-time</Pill>

                        <Pill right="-4%" top="53%" delay={0.3}>Easy registration with one tap</Pill>
                        <Pill right="0%" top="74%" delay={0.5}>Player stats & match insights</Pill>

                    </div>
                </div>
            </section>
        </>
    )
}

export default QuivverBanner;

const Pill = ({ children, left, right, top, delay = 0 }: any) => {
    const isLeft = !!left

    const borderRadius = isLeft
        ? '0px 20px 20px 0px'
        : '20px 0px 0px 20px'

    const borderGradient = isLeft
        ? 'linear-gradient(270deg, #2DEE9A 0%, rgba(185,34,210,0) 100%)'
        : 'linear-gradient(90deg, #2DEE9A 0%, rgba(185,34,210,0) 100%)'

    const bgGradient = isLeft
        ? 'linear-gradient(270deg, rgba(45, 238, 154, 0.23) 50%, rgba(185,34,210,0) 100%)'
        : 'linear-gradient(90deg, rgba(45, 238, 154, 0.23) 55%, rgba(185,34,210,0) 100%)'

    const animationClass = isLeft ? 'animate-slide-in-left' : 'animate-slide-in-right'
    const positionClass = isLeft ? 'pill-left' : 'pill-right'

    // Extract numeric value from top prop for responsive class
    const topValue = typeof top === 'string' ? parseInt(top.replace('%', '')) : null
    const topClass = topValue ? `pill-top-${topValue}` : ''

    // const shadow = isLeft
    //     ? '-12px 0 40px rgba(45, 238, 154, 0.23)'
    //     : '12px 0 40px rgba(45, 238, 154, 0.23)'

    return (
        <div
            className={`absolute z-30 opacity-0 ${animationClass} ${positionClass} ${topClass} block`}
            style={{
                left: isLeft ? (typeof left === 'string' ? left : undefined) : undefined,
                right: !isLeft ? (typeof right === 'string' ? right : undefined) : undefined,
                top: typeof top === 'string' ? top : undefined,
                animationDelay: `${delay}s`
            }}
        >
            {/* Border */}
            <div
                className="p-[1px] sm:p-[1px]"
                style={{
                    borderRadius,
                    background: borderGradient
                }}
            >
                {/* Dark frame */}
                <div
                    className="p-[0.6px] sm:p-[0.6px] bg-[#0F0D16]"
                    style={{ borderRadius }}
                >
                    {/* Glass fill */}
                    <div
                        className="
                flex items-center gap-1.5 sm:gap-2 md:gap-3
                px-[clamp(8px,1vw,18px)]
                py-[clamp(4px,0.6vw,10px)]
                backdrop-blur-xl
                text-white text-[clamp(10px,0.9vw,14px)]
                font-semibold
                max-w-[85vw] sm:max-w-[75vw] md:max-w-none
              "
                        style={{
                            borderRadius,
                            background: bgGradient,
                            // boxShadow: shadow
                        }}
                    >
                        <span className="text-sm sm:text-base md:text-xl leading-none flex-shrink-0">•</span>
                        <span className="whitespace-normal sm:whitespace-nowrap text-[clamp(9px,0.85vw,14px)]">{children}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}



